document.addEventListener('algolia.hooks.initialize', function() {
  algoliaShopify.hooks.registerHook('beforeInstantSearchMainTemplate', function(_defaultTemplate, data, html) {
    let translations = {
      filters_header: "Filteren"
    }; 

    const translationsJson = document.querySelector('#algolia-translations');
    if (translationsJson) {
      translations = JSON.parse(translationsJson.innerHTML);
    }

    document.addEventListener('layout:rendered', function() {
      document.querySelector('.ais-facets-close').addEventListener('click', () => {
        document.querySelector('.ais-facets-button').click();
      });
    });

    return html`
      <div class="ais-page collection-quick-add-bulk" id="ais-search-products-container" data-id="ais-search-products">
        <h1 class="ais-h2 hidden">${algoliaShopify.translations.searchTitle}</h1>
        <div class="ais-input hidden">
          <div class="ais-search-box-container"></div>
          <div class="ais-input-button">
            <div class="ais-clear-input-icon"></div>
          </div>
        </div>
        <div class="ais-facets-button">
          Show filters
        </div>
        <div class="ais-facets">
          <div class="ais-facets-header">
            <span class="h2">
              ${translations.filters_header}
            </span>
            <div class="ais-facets-close">
              <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" class="icon icon-close" fill="none" viewBox="0 0 18 17">
                <path d="M.865 15.978a.5.5 0 00.707.707l7.433-7.431 7.579 7.282a.501.501 0 00.846-.37.5.5 0 00-.153-.351L9.712 8.546l7.417-7.416a.5.5 0 10-.707-.708L8.991 7.853 1.413.573a.5.5 0 10-.693.72l7.563 7.268-7.418 7.417z" fill="currentColor" />
              </svg>
            </div>
            <script>
              document.dispatchEvent(new CustomEvent('layout:rendered'));
            </script>
          </div>
          <div class="ais-clear-refinements-container"></div>
          <div class="ais-current-refined-values-container"></div>
          ${data.facets.map(
            facet =>
              html`
                <simple-accordion
                  style="border: none; margin-bottom: 1.6rem;"
                  class="ais-facet-dropdown-wrapper ais-facet-${facet.type} ais-facet-${facet.escapedName}"
                >
                  <button 
                    type="button"
                    class="button button--tertiary simple-accordion--opener button--no-underline button--facet"
                    aria-expanded="false"
                  >
                    <span class="simple-accordion--title">
                      ${facet.title}
                    </span>

                    <span class="simple-accordion--icon">
                      <span class="plus-minus"></span>
                    </span>
                    
                    <label
                      for="${facet.escapedName}"
                      class="ais-range-slider--header ais-facet--header ais-header hidden"
                    >${facet.title}</label>
                    <input
                      class="ais-dropdown-checkbox hidden"
                      type="checkbox"
                      id="${facet.escapedName}"
                      name="dropdown"
                      checked
                    />
                  </button>

                  <div
                    class="simple-accordion--content"
                    aria-hidden="true"
                  >
                    <div class="ais-facet-${facet.escapedName}-container ais-facet-dropdown-container"></div>
                  </div>
                </simple-accordion>
              `
          )}
        </div>
        <div class="ais-block">
          <div class="ais-search-header">
            <div class="ais-stats-container"></div>
            <div class="sort-layout-container">
              <div class="ais-sort">
                ${data.multipleSortOrders
                  ? html`
                      <span class="ais-sort-orders-container"></span>
                    `
                  : html`
                      ${algoliaShopify.translations.sortBy}
                      ${algoliaShopify.translations.relevance}
                    `}
              </div>
              
              <layout-changer class="no-js-hidden colorscheme-27328eed-c441-4870-8a8d-b2e7f7a37b52" data-poll-grid data-add-grid-id>
                <button class="button button--tertiary button--square-icon button--no-sizing" type="button" data-type="grid">
                  <svg class="icon icon-grid-view" aria-hidden="true" focusable="false" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M2.375.5H4.95a1.875 1.875 0 0 1 1.875 1.883V4.95c0 1.036-.84 1.875-1.875 1.875H2.375A1.875 1.875 0 0 1 .5 4.95V2.383A1.875 1.875 0 0 1 2.375.5M4.95 5.567a.633.633 0 0 0 .625-.625V2.383a.625.625 0 0 0-.625-.625H2.375a.625.625 0 0 0-.625.625v2.559c.004.343.282.62.625.625zM11.05.5h2.575A1.875 1.875 0 0 1 15.5 2.383V4.95c0 1.036-.84 1.875-1.875 1.875H11.05A1.875 1.875 0 0 1 9.175 4.95V2.375c0-1.036.84-1.875 1.875-1.875m2.575 5.067a.633.633 0 0 0 .625-.625V2.383a.625.625 0 0 0-.625-.625H11.05a.625.625 0 0 0-.625.625v2.559c.005.343.282.62.625.625zM2.375 9.175H4.95c1.036 0 1.875.84 1.875 1.875v2.575c0 1.036-.84 1.875-1.875 1.875H2.375A1.875 1.875 0 0 1 .5 13.617V11.05c0-1.036.84-1.875 1.875-1.875m2.575 5.067c.345 0 .625-.28.625-.625V11.05a.633.633 0 0 0-.625-.625H2.375a.633.633 0 0 0-.625.625v2.567c0 .345.28.625.625.625zm6.1-5.067h2.575c1.036 0 1.875.84 1.875 1.875v2.567a1.875 1.875 0 0 1-1.875 1.883H11.05a1.875 1.875 0 0 1-1.875-1.883V11.05c0-1.036.84-1.875 1.875-1.875m2.575 5.067c.345 0 .625-.28.625-.625V11.05a.633.633 0 0 0-.625-.625H11.05a.633.633 0 0 0-.625.625v2.567c0 .345.28.625.625.625z" fill="currentColor"></path>
                  </svg>
                </button>
                <button class="button button--tertiary button--square-icon button--no-sizing" type="button" data-type="list">
                  <svg class="icon icon-list-view" aria-hidden="true" focusable="false" xmlns="http://www.w3.org/2000/svg" width="14" height="16" viewBox="0 0 14 16" fill="none">
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M2 .917h10c.92 0 1.667.746 1.667 1.666v2.5c0 .92-.746 1.667-1.667 1.667H2c-.92 0-1.667-.746-1.667-1.667v-2.5C.333 1.663 1.08.917 2 .917M12 5.5c.23 0 .417-.187.417-.417v-2.5A.417.417 0 0 0 12 2.166H2a.417.417 0 0 0-.417.417v2.5c0 .23.187.417.417.417zM2 9.25h10c.92 0 1.667.746 1.667 1.666v2.5c0 .921-.746 1.667-1.667 1.667H2c-.92 0-1.667-.746-1.667-1.667v-2.5c0-.92.747-1.666 1.667-1.666m10 4.583c.23 0 .417-.186.417-.417v-2.5A.417.417 0 0 0 12 10.5H2a.417.417 0 0 0-.417.416v2.5c0 .23.187.417.417.417z" fill="currentColor"></path>
                  </svg>
                </button>
              </layout-changer>

              <div class="ais-change-display hidden">
                <span class="ais-change-display-block ais-change-display-selected"></span>
                <span class="ais-change-display-list"></span>
              </div>
            </div>
          </div>
          <div class="ais-hits-container ais-results-as-block"></div>
        </div>
        <div class="ais-pagination-container"></div>
      </div>
    `;
  });

  algoliaShopify.hooks.registerHook('afterISStartRemoveDefaultWidget', function(defaultWidgets) {
    const defaultHits = defaultWidgets.find(
      widget => widget.$$widgetType === 'ais.hits'
    );
    /*const defaultSearchBox = defaultWidgets.find(
      widget => widget.$$widgetType === 'ais.searchBox'
    );*/

    return [defaultHits/*, defaultSearchBox*/];
  });

  window.algoliaTimerId = null;
  window.algoliaTimeout = 200;
  window.algoliaFilterCache = {};
  
  algoliaShopify.hooks.registerHook('beforeISStartAddWidgetArray', function() {
    const hitsWidget = window.algoliaShopify.externals.widgets.hits({
      container: '.ais-hits-container',
      transformItems(items, { results }) {
        const ids = items.sort((a, b) => a - b).map(t => `id:${ t.id }`).join(' OR ');

        let products = null;
        if (typeof window.algoliaFilterCache[ids] !== 'undefined') {
          products = window.algoliaFilterCache[ids];
        } else {
          const xhr = new XMLHttpRequest();
  
          xhr.open('GET', `/search?q=${ ids }&section_id=algolia-search-results&type=product`, false);
          xhr.setRequestHeader('credentials', 'same-origin');
          xhr.send(null);
  
          products = new DOMParser().parseFromString(xhr.responseText, 'text/html').querySelectorAll('[data-product-id]');

          window.algoliaFilterCache[ids] = products;
        }

        return items.map(t => {
          for (const product of products) {
            if (product.getAttribute('data-product-id') == t.id) {
              return {
                ...t,
                html: product.outerHTML
              };
            }
          }
          console.log('product not found ' + t.id);
          return {
            ...t,
            html: ''
          };
        });
      },
      templates: {
        item(hit, { html, components }) {
          return html`
            ${hit.html}
          `;
        },
        empty(results) { return `
                  <style> 
                    .no-results-message {padding: 0 0.9em !important;}
                    .no-results-message p {padding-bottom: 7px; line-height: 25px;}
                  </style>
                  <div class="no-results-message">
                   <p> ${window.themeStrings.noProductsFound} "<strong>${results.query}</strong>" </p>
                 </div>
          `;}
      },
      cssClasses: {
        list: ['ais-Hits-list', 'grid', 'product-grid', 'grid--2-col', 'grid--2-col-tablet-down', 'grid--2-col-tablet', 'grid--3-coltablet-grid', 'grid--4-col-widescreen'],
        item: ['grid__item', 'ais-Hits-item']
      },
    });

    /*const searchBoxWidget = window.algoliaShopify.externals.widgets.searchBox({
      container: '.ais-search-box-container',
      queryHook(query, refine) {
        clearTimeout(window.algoliaTimerId);
        window.algoliaTimerId = setTimeout(() => refine(query), window.algoliaTimeout);
      }
    });*/

    return [hitsWidget/*, searchBoxWidget*/];
  });
});